<template lang="pug">
.countrylist_item.d-flex.flex-row.flex-md-column.align-items-md-center
  a(:href="link",target="_blank" )
    img(:src="icon")
    .infos.w-100.d-flex.flex-column.align-items-md-center.i_mt_4.i_mt_sm_0.flex-grow-1.flex-md-grow-0
      .title.d-flex.align-items-center
        h5.i_ml_sm_5 {{ title }}
</template>

<script>
export default {
  name: "CountrylistItem",
  props: {
    title: String,
    icon: String,
    link: String,
  },
  components: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/countrylist_item";
</style>
